import React from "react";
import "../components/Blog.css";
import {NavLink} from "react-router-dom";

const Sitemap = () => {
  return (
    <div>
      {/* Header */}
      <header className="blog-hero">
        <div className="container">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1>Sitemap</h1>
              <p>Explore all pages & resources at CodeInputs</p>
            </div>
          </div>
        </div>
      </header>

      {/* Sitemap Section */}
      <section className="blog-wrapper">
        <div className="container">
          <div className="row">

            {/* Left Content */}
            <div className="col-lg-8">
              <div className="blog-card">

                <h2>Pages</h2>
                <ul>
                  <li><NavLink to="/">Home</NavLink></li>
                  <li><NavLink to="/#about-premium">About</NavLink></li>
                  <li>
                    <NavLink to="/">Services</NavLink>
                    <ul className="sub-links">
                      <li><NavLink to="/">Web Development</NavLink></li>
                      <li><NavLink to="/">Software Development</NavLink></li>
                      <li><NavLink to="/">Application Development</NavLink></li>
                      <li><NavLink to="/">Custom API & Integration</NavLink></li>
                      <li><NavLink to="/">Social Media Handling</NavLink></li>
                      <li><NavLink to="/">Graphics Designing</NavLink></li>
                      <li><NavLink to="/">Logo Designing</NavLink></li>
                    </ul>
                  </li>
                  <li><NavLink to="/contact">Contact</NavLink></li>
                </ul>

                <h2>All Tools</h2>
                <ul>
                  <li><NavLink to="/colorpickertool">Color Code Genarator</NavLink></li>
                  <li><NavLink to="/jpegtopdfconverter">JPEG TO PDF Converter</NavLink></li>
                  <li><NavLink to="/pngtopdfconverter">PNG TO PDF Converter</NavLink></li>
                  <li><NavLink to="/jsonviewertool">JSON Viewer Tool</NavLink></li>
                  <li><NavLink to="/qrcodegenrator">QR Code Generator</NavLink></li>
                  <li><NavLink to="/barcodegenrator">Barcode Generator</NavLink></li>
                </ul>

                <h2>All Blogs</h2>
                <ul className="blogs-list">
                  <li><NavLink to="/adobe_pdf">Adobe PDF Tools</NavLink></li>
                  <li><NavLink to="/notepad_plugins">Top Notepad++ Plugins</NavLink></li>
                  <li><NavLink to="/http_502">HTTP 502 Errors</NavLink></li>
                  <li><NavLink to="/cxx">CXX File Format</NavLink></li>
                  <li><NavLink to="/winscp">WinSCP Unleashed: The Definitive Guide</NavLink></li>
                  <li><NavLink to="/cpanelpassword">Cpanel Password Change</NavLink></li>
                  <li><NavLink to="/clearingcache">Clearing Cache on Cpanel</NavLink></li>
                  <li><NavLink to="/filezilla">Getting Started with Filezilla</NavLink></li>
                  <li><NavLink to="/ftp">FTP Account in Cpanel</NavLink></li>
                  <li><NavLink to="/turbopayz">TurboPayz vs Other Payment Gateways</NavLink></li>
                </ul>
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-lg-4">
              <div className="blog-sidebar">

                <div className="sidebar-card">
                  <h3>Other Pages</h3>
                  <ul>
                    <li><NavLink to="/privacypolicy">Privacy Policy</NavLink></li>
                    <li><NavLink to="/disclaimer">Disclaimer</NavLink></li>
                    <li><NavLink to="/termsncondition">Terms & Conditions</NavLink></li>
                    <li><NavLink to="/sitemap">Sitemap</NavLink></li>
                  </ul>
                </div>

                <div className="sidebar-card text-center">
                  <h5 className="mb-2">Need Custom Software?</h5>
                  <p className="small text-muted mb-3">
                    Let’s build something amazing together.
                  </p>
                  <NavLink to="/contact" className="btn btn-primary w-100">
                    Contact Us
                  </NavLink>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Sitemap;
